export enum RequestStep_Enum {
  sourceSelection = 0,
  destinationSelection = 1,
  categorySelection = 2,
  optionsSelection = 3,
  reserveTimeSelection = 4,
  confirmReserveTime = 5,
  extraDestinationSelection = 6,
  searchingDriver = 7,
  passngerExtraInfo = 8,
}

export enum FavoriteLocation_Enum {
  Disable = 0,
  AddPoint = 1,
  SubmitForm = 2,
}

export enum SortType_Enum {
  // صعودی
  Ascending = 1,
  // نزولی
  Descending = 2,
}
